export default __webpack_public_path__ + "static/media/pic11.cf116dcb.jpg";